// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var Matrix = /* #__PURE__ */ (function () {
    function Matrix(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    };
    Matrix.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return function (value4) {
                        return function (value5) {
                            return new Matrix(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Matrix;
})();
var Translate = /* #__PURE__ */ (function () {
    function Translate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Translate.create = function (value0) {
        return function (value1) {
            return new Translate(value0, value1);
        };
    };
    return Translate;
})();
var Scale = /* #__PURE__ */ (function () {
    function Scale(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Scale.create = function (value0) {
        return function (value1) {
            return new Scale(value0, value1);
        };
    };
    return Scale;
})();
var Rotate = /* #__PURE__ */ (function () {
    function Rotate(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Rotate.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Rotate(value0, value1, value2);
            };
        };
    };
    return Rotate;
})();
var SkewX = /* #__PURE__ */ (function () {
    function SkewX(value0) {
        this.value0 = value0;
    };
    SkewX.create = function (value0) {
        return new SkewX(value0);
    };
    return SkewX;
})();
var SkewY = /* #__PURE__ */ (function () {
    function SkewY(value0) {
        this.value0 = value0;
    };
    SkewY.create = function (value0) {
        return new SkewY(value0);
    };
    return SkewY;
})();
var showTransform = {
    show: function (v) {
        if (v instanceof Matrix) {
            return "(Matrix " + (show(v.value0) + (" " + (show(v.value1) + (" " + (show(v.value2) + (" " + (show(v.value3) + (" " + (show(v.value4) + (" " + (show(v.value5) + ")")))))))))));
        };
        if (v instanceof Translate) {
            return "(Translate " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        };
        if (v instanceof Scale) {
            return "(Scale " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        };
        if (v instanceof Rotate) {
            return "(Rotate " + (show(v.value0) + (" " + (show(v.value1) + (" " + (show(v.value2) + ")")))));
        };
        if (v instanceof SkewX) {
            return "(SkewX " + (show(v.value0) + ")");
        };
        if (v instanceof SkewY) {
            return "(SkewY " + (show(v.value0) + ")");
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Transform (line 19, column 10 - line 25, column 42): " + [ v.constructor.name ]);
    }
};
var printTransform = function (v) {
    if (v instanceof Matrix) {
        return "matrix(" + (show(v.value0) + ("," + (show(v.value1) + ("," + (show(v.value2) + ("," + (show(v.value3) + ("," + (show(v.value4) + ("," + (show(v.value5) + ")")))))))))));
    };
    if (v instanceof Translate) {
        return "translate(" + (show(v.value0) + ("," + (show(v.value1) + ")")));
    };
    if (v instanceof Scale) {
        return "scale(" + (show(v.value0) + ("," + (show(v.value1) + ")")));
    };
    if (v instanceof Rotate) {
        return "rotate(" + (show(v.value0) + ("," + (show(v.value1) + ("," + (show(v.value2) + ")")))));
    };
    if (v instanceof SkewX) {
        return "skewX(" + (show(v.value0) + ")");
    };
    if (v instanceof SkewY) {
        return "skewY(" + (show(v.value0) + ")");
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Transform (line 28, column 18 - line 34, column 39): " + [ v.constructor.name ]);
};
var eqTransform = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Matrix && y instanceof Matrix) {
                return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2 && x.value3 === y.value3 && x.value4 === y.value4 && x.value5 === y.value5;
            };
            if (x instanceof Translate && y instanceof Translate) {
                return x.value0 === y.value0 && x.value1 === y.value1;
            };
            if (x instanceof Scale && y instanceof Scale) {
                return x.value0 === y.value0 && x.value1 === y.value1;
            };
            if (x instanceof Rotate && y instanceof Rotate) {
                return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2;
            };
            if (x instanceof SkewX && y instanceof SkewX) {
                return x.value0 === y.value0;
            };
            if (x instanceof SkewY && y instanceof SkewY) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
export {
    Matrix,
    Translate,
    Scale,
    Rotate,
    SkewX,
    SkewY,
    printTransform,
    eqTransform,
    showTransform
};
